import React, { Suspense, useEffect, useState } from "react";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import Loader from "../Layout/Loader";
import { authRoutes } from "./AuthRoutes";
import LayoutRoutes from "../Route/LayoutRoutes";
import PrivateRoute from "./PrivateRoute";
import { classes } from "../Data/Layouts";
import { ErrorBoundary } from "../_helper/ErrorBoundary";
import NotFound from "../Components/Errors/NotFound";
import ServerError from "../Components/Errors/ServerError";

const Signin = React.lazy(() => import("../Auth/Signin"));
const SetPassword = React.lazy(
  () => import("../Components/SetPassword/SetPassword"),
);
const MeetingList = React.lazy(
  () => import("../Components/Application/Admin/MeetingPage/MeetingList"),
);
const MeetingPage = React.lazy(
  () => import("../Components/Application/Admin/MeetingPage/MeetingPage"),
);

const Routers = () => {
  const login = useState(JSON.parse(localStorage.getItem("login")))[0];
  const [authenticated, setAuthenticated] = useState(false);
  const defaultLayoutObj = classes.find(
    (item) => Object.values(item).pop(1) === "compact-wrapper",
  );
  const layout =
    localStorage.getItem("layout") || Object.keys(defaultLayoutObj).pop();

  useEffect(() => {
    let abortController = new AbortController();
    setAuthenticated(JSON.parse(localStorage.getItem("authenticated")));
    console.ignoredYellowBox = ["Warning: Each", "Warning: Failed"];
    console.disableYellowBox = true;
    return () => {
      abortController.abort();
    };
  }, []);

  const user = JSON.parse(localStorage.getItem("authUser"));
  const isAdmin = user?.role === "admin" || user?.role === "superadmin";

  return (
    <ErrorBoundary componentName="Router">
      <BrowserRouter basename={"/"}>
        <Suspense fallback={<Loader />}>
          <Routes>
            <Route path={"/"} element={<PrivateRoute />}>
              {login || authenticated ? (
                <>
                  <Route
                    path={`${process.env.PUBLIC_URL}`}
                    element={
                      isAdmin ? (
                        <Navigate
                          to={`${process.env.PUBLIC_URL}/dashboard/${layout}`}
                        />
                      ) : (
                        <Navigate
                          to={`${process.env.PUBLIC_URL}/dashboard/${layout}`}
                        />
                      )
                    }
                  />
                  <Route
                    path={`/`}
                    element={
                      isAdmin ? (
                        <Navigate
                          to={`${process.env.PUBLIC_URL}/dashboard/${layout}`}
                        />
                      ) : (
                        <Navigate
                          to={`${process.env.PUBLIC_URL}/mursal-meetings`}
                        />
                      )
                    }
                  />
                </>
              ) : null}
              <Route
                path={`${process.env.PUBLIC_URL}/*`}
                element={<LayoutRoutes />}
              />
            </Route>

            <Route
              path={`${process.env.PUBLIC_URL}/login`}
              element={
                <ErrorBoundary componentName="Login">
                  <Signin />
                </ErrorBoundary>
              }
            />
            <Route
              path={`${process.env.PUBLIC_URL}/login/:meetingId`}
              element={
                <ErrorBoundary componentName="LoginWithMeeting">
                  <Signin />
                </ErrorBoundary>
              }
            />
            <Route
              path={`${process.env.PUBLIC_URL}/set-password`}
              element={
                <ErrorBoundary componentName="SetPassword">
                  <SetPassword />
                </ErrorBoundary>
              }
            />

            <Route
              path={`${process.env.PUBLIC_URL}/mursal-meetings`}
              element={
                <ErrorBoundary componentName="MeetingList">
                  <MeetingList />
                </ErrorBoundary>
              }
            />
            <Route
              path={`${process.env.PUBLIC_URL}/mursal-meetings/:meetingId`}
              element={
                <ErrorBoundary componentName="MeetingPage">
                  <MeetingPage />
                </ErrorBoundary>
              }
            />

            {authRoutes.map(({ path, Component }, i) => (
              <Route
                key={i}
                path={path}
                element={
                  <ErrorBoundary componentName={`AuthRoute-${i}`}>
                    {Component}
                  </ErrorBoundary>
                }
              />
            ))}

            <Route
              path={`${process.env.PUBLIC_URL}/404`}
              element={<NotFound />}
            />
            <Route
              path={`${process.env.PUBLIC_URL}/500`}
              element={<ServerError />}
            />

            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </ErrorBoundary>
  );
};

export default Routers;
